import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appShowAfterScroll]',
  standalone: true,
})
export class ShowAfterScrollDirective implements OnInit, OnDestroy {
  @Input('scrollOffsetPixels') scrollOffset = 200;

  private scrollContainer: HTMLElement | Window = window;
  private removeWindowScrollListener?: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    // hide by default
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    this.renderer.setStyle(this.el.nativeElement, 'visibility', 'hidden');
    this.renderer.setStyle(
      this.el.nativeElement,
      'transition',
      'opacity 0.15s ease'
    );

    this.setupScrollListeners();

    // Sync visibility on first render in case the view loads at a scrolled position.
    requestAnimationFrame(() => this.updateVisibility());
  }

  ngOnDestroy(): void {
    this.removeWindowScrollListener?.();
  }

  private setupScrollListeners() {
    this.removeWindowScrollListener = this.renderer.listen(
      'window',
      'scroll',
      () => this.updateVisibility()
    );
  }

  private updateVisibility() {
    const scrollTop = this.getScrollTop();

    if (scrollTop > this.scrollOffset) {
      this.show();
    } else {
      this.hide();
    }
  }

  private getScrollTop(): number {
    const container = this.scrollContainer;

    if (container instanceof Window) {
      return (
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      );
    }

    return container.scrollTop;
  }

  private show() {
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    this.renderer.setStyle(this.el.nativeElement, 'visibility', 'visible');
  }

  private hide() {
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    this.renderer.setStyle(this.el.nativeElement, 'visibility', 'hidden');
  }
}
